import { FC } from 'react';
import { ArchivedCaseListCommonContainer } from '../../../../../shared/related-cases/archived-case-list-common.container';

interface ArchivedCaseListContainerProps {
  applicantId: string;
  caseId: string;
  isVerticalColumn?: boolean;
}

export const ArchivedCaseListContainer: FC<ArchivedCaseListContainerProps> = (props) => {
  return <ArchivedCaseListCommonContainer applicantId={props.applicantId} isVerticalColumn={props?.isVerticalColumn} />;
};
